import React from 'react';
import classes from './VerifiedBadge.module.css';
const verifiedBadge = (props) => {
    return (
        <div className={classes.VerifiedBadge}>
            <span style={{backgroundColor: props.color}}></span>
        </div>
    )
}
export default verifiedBadge;